import FormstepDetail from "../../../../../global/components/FormstepDetail/FormstepDetail.vue";

import HttpMixin from "../../../../../global/mixins/HttpMixin";
import NotificationMixin from "../../../../../global/mixins/NotificationMixin";

import {
  cloneDeep,
} from "lodash-es";

// @vue/component
export default {
  name: "Basisdaten",
  components: {
    FormstepDetail,
  },
  mixins: [
    HttpMixin,
    NotificationMixin,
  ],
  props: {
    budget: {
      type: Object,
      required: true,
    },
    updateBudget: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      options: {
        label: "_TXT_BUDGET_DETAILS_BASISDATEN_PANEL_FORMSTEP_NAME_",
        list: [
          {
            id: "bud_kbez",
            type: "text",
            label: "_LBL_BUDGET_DETAILS_BASISDATEN_KURZ_BEZEICHNUNG_",
            showLabel: true,
            view: "v-alt",
            required: true,
            translate: true,
          },
          {
            id: "bud_betrag",
            type: "currency",
            label: "_LBL_BUDGET_DETAILS_BASISDATEN_BETRAG_",
            showLabel: true,
            view: "v-alt",
            translate: true,
          },
          {
            id: "verteilt",
            readonly: true,
            type: "currency",
            label: "_LBL_BUDGET_DETAILS_BASISDATEN_VERTEILT_",
            showLabel: true,
            view: "v-alt",
            translate: true,
          },
          {
            id: "verfuegbar",
            readonly: true,
            type: "currency",
            label: "_LBL_BUDGET_DETAILS_BASISDATEN_VERFUEGBAR_",
            showLabel: true,
            view: "v-alt",
            translate: true,
          },
          {
            id: "bud_bez",
            type: "richtext",
            label: "_LBL_BUDGET_DETAILS_BASISDATEN_BESCHREIBUNG_",
            showLabel: true,
            view: "v-alt",
            translate: true,
          },
        ],
        required: true,
        saveCallback: this.save,
        editablePermission: "budget.update",
      },
    };
  },
  methods: {
    save({ model }) {
      const DATA = cloneDeep(model);
      return new Promise((resolve, reject) => {
        this.putHttp({
          url: `budgets/${ this.budget.pk }/`,
          data: DATA,
        }).then(
          response => {
            this.updateBudget({ budget: response });
            this.addNotification({ text: "_MSG_BUDGET_DETAILS_UPDATE_SUCCESS_" });
            resolve();
          },
          error => {
            reject(error);
          }
        );
      });
    },
  },
};
